import React from "react";
import PremiumCalculatorBase from "./PremiumCalculatorBase";

const PremiumCalculatorPublic = () => <PremiumCalculatorBase variant="public" />;

export default PremiumCalculatorPublic;
